import request from "@/utils/request";

// 抽奖商品管理
export const prize = {
  // 列表
  list: () =>
    request({
      url: "/api/backend/draw/list",
      method: "GET",
      params: {},
    }),
  add:(data) =>
    request({
      url: "/api/backend/draw/add",
      method: "POST",
      data
    }),
  delete:(id) => 
    request({
      url:"/api/backend/draw/del",
      method:"POST",
      data:{id}
    })
};

// 中奖名单
export const lucky = {
  //列表
  list: (params) =>
    request({
      url: "/api/backend/draw/prize/log",
      method: "GET",
      params: { ...params },
    }),
  delivery:(data) =>
    request({
      url:"/api/backend/draw/delivery",
      method:"POST",
      data
    }),
  sign:(id) =>
    request({
      url:"/api/backend/draw/signing",
      method:"POST",
      data:{id}
    }),
    // excel 接口
  exportLuckyExcel:(params) =>
    request({
      url:"/api/backend/excel/draw",
      method:"GET",
      params
    }),
};

// 抽奖记录
export const sweepstakesRecord = {
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/draw/log",
      method: "GET",
      params: { ...params },
    }),
};
